import React from 'react';
// DropdownMenu is deprecated in radial 5, but the composed alternative behaves
// erratically when implemented in dealer portal, so we're using the old one
import { DropdownMenu, DROPDOWN_VARIANTS } from 'cdk-radial';

export default function DMSDropdown({
  location,
  address,
  dmsAccountType,
  departments = [],
  handleSelectDMS,
  selectedDMS: legacySelectedDMS,
  selectedDepartments = [],
  cmfNumber,
  entityId,
  type,
  id,
  api,
}) {
  const handleChange = selectedOptions => {
    const newDepartments = selectedOptions.map(o => ({
      name: o.label,
      id: o.value
    }));

    handleSelectDMS(
      location,
      selectedOptions.map(o => o.label).join(','),
      newDepartments,
      cmfNumber,
      dmsAccountType,
      entityId,
      type,
      id,
      api,
    );
  };

  const options = departments.map(d => ({ label: d.name, value: d.id }));
  const initSelections = options.filter(
    o => selectedDepartments.some(d => d.id === o.value) || legacySelectedDMS === o.label
  );

  return (
    <div className="locations-grid">
      <div className="location-block">
        <div className="location-name">{location}</div>
        <div className="location-address">{address}</div>
      </div>
      <div id={`dms-dropdown-${entityId}`} className="dms-dropdown">
        <DropdownMenu
          inputId={`dms-${dmsAccountType}-${id}`}
          dataTestId={`dms-${dmsAccountType}-${id}`}
          onChange={handleChange}
          isMulti={true}
          options={options}
          value={initSelections}
          variant={DROPDOWN_VARIANTS.INLINE}
          placeholder="Select DMS Accounts"
        />
      </div>
    </div>
  );
}
